<app-accordion-item>
  <div app-accordion-header class="flex items-center justify-start gap-4" translate>
    <div>
      <input app-checkbox [ngModel]="isSelected" class="text-theme-950" type="checkbox" (click)="onSelect($event)" />
    </div>
    <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-gray-300">
      <img
        app-img
        class="h-12 w-12 select-none rounded-lg"
        [src]="subdivision.thumbnail"
        onerror="src='assets/images/default.png'"
      />
    </div>
    <div class="text-lg font-medium text-theme-700">{{ subdivision.name }}</div>
  </div>
  <div class="absolute -left-[4.5%] -top-14 z-0 w-5 border border-b border-theme-500 opacity-70 md:w-6 2xl:w-10"></div>
  <div app-accordion-content class="rounded-lg bg-linear-to-r from-white via-theme-50 to-theme-100">
    <app-accordion class="relative w-full">
      <div class="absolute left-[4%] h-full border border-l border-theme-500 opacity-70"></div>
      @if (subdivision.subdivisoes) {
        @for (subdivisionIn of subdivision.subdivisoes; track subdivisionIn) {
          <div class="flex w-full flex-col items-end justify-center">
            <app-card-subdivision class="relative w-11/12" [subdivision]="subdivisionIn"></app-card-subdivision>
          </div>
        }
      }
      @if (subdivision.trilhas) {
        @for (trail of subdivision.trilhas; track trail) {
          <div class="flex w-full flex-col items-end justify-center">
            <app-card-trail class="relative w-11/12" [trail]="trail"></app-card-trail>
          </div>
        }
      }
    </app-accordion>
  </div>
</app-accordion-item>
